module.exports = __webpack_public_path__ + "img/dcg1.7df6e6ae.jpg";